export default __webpack_public_path__ + "static/media/crc-block-pp.84d82aca.svg";